/* eslint react/jsx-no-bind:0 */
import React, { Component } from "react"
import { Link, withRouter } from "react-router-dom"
import { connect } from 'react-redux'
import { object } from "prop-types"
import pubsub from "pubsub-js"
import { checkRole } from '../../utils/helperfunctions'
import SidebarRun from "./Sidebar.run"

class Sidebar extends Component {
  static propTypes = {
    history: object,
    location: object
  }
  constructor(props, context) {
    super(props, context);
    this.state = {
      // resetpage:false
      // collapse: {
      //   dashboard: this.routeActive(["dashboard"]),
      // },
      isAdmin:false,
      roleChecked:false
    }
    this.handleResetScreen = this.handleResetScreen.bind(this)
    this.applyPermission =  this.applyPermission.bind(this)
  }

  componentDidMount() {
    // pass navigator to access router api
    SidebarRun(this.navigator.bind(this))
  }

  componentWillUnmount() {
    // React removed me from the DOM, I have to unsubscribe from the pubsub using my token
    pubsub.unsubscribe(this.pubsub_token)
  }

  handleResetScreen() {
  //  this.setState({ resetpage:true })
  }

  navigator(route) {
    const { history } = this.props
    history.push(route)
  }

  routeActive(paths) {
    paths = Array.isArray(paths) ? paths : [paths];
    if (paths.indexOf(this.props.location.pathname.replace("/", "")) > -1) return true;
    return false
  }
  applyPermission()
  {
    const { user } = this.props.oidc
    const { roleChecked } = this.state

    if ((user != null) && (!roleChecked))
    {
      const token = user.access_token
      const _this = this
      checkRole(token).then(function(response) {
        if (response.data) {
          _this.setState({ 
            isAdmin:response.data,
            roleChecked:true
          })
        }
      })
    }
  }
 
/*   // toggleItemCollapse(stateName) {
  //   // const newCollapseState = {};
  //   for (const c in this.state.collapse) {
  //     if (this.state.collapse[c] === true && c !== stateName) this.state.collapse[c] = false;
  //   }
  //   this.setState({
  //     collapse: {
  //       [stateName]: !this.state.collapse[stateName],
  //     },
  //   });
  // } */

  render() {

    const { isAdmin } = this.state
    this.applyPermission()

    return (
      <aside className="aside" >
        {/* START Sidebar (left) */}
         <div className="aside-inner">
          <nav data-sidebar-anyclick-close className="sidebar">
            {/* START sidebar nav */}
            <ul className="nav">
              {/* Iterates over all sidebar items */}
             {/*  <li className="nav-heading">
                <span>Collegiate</span>
              </li> */}
              <li className={this.routeActive("dashboard") ? "active" : ""}>
                <Link to="dashboard" title="Dashboard">
                  <em className="fa fa-tachometer" />
                  <span>Dashboard</span>
                </Link>
              </li>
             { isAdmin && (<li>
                <a href="#tournamentarea" title="Event Management">
                  <em className="fa fa-calendar" />
                  <span>Season</span>
                </a>
                <ul id="tournamentarea" className="nav sidebar-subnav">  
                  <li className={this.routeActive(["seasonsettings"]) ? "active" : ""}>
                    <Link to="seasonsettings" title="Tournament setup settings">                
                      <span>Season Settings</span>
                    </Link>
                  </li>
                  <li className={this.routeActive(["reports"]) ? "active" : ""}>
                    <Link to="reports" title="View Exceptions">                
                      <span>Reports</span>
                    </Link>
                  </li>
                </ul>
             </li>) }
            <li>
                <a href="#tournamentarea" title="Event Management">
                  <em className="fa fa-calendar-plus-o" />
                  <span>Event</span>
                </a>
                <ul id="tournamentarea" className="nav sidebar-subnav">
               {/*    <li className={this.routeActive(["upcoming"]) ? "active" : ""}>
                    <Link to="upcomingevents" title="View Upcoming Events">                
                        <span>View Upcoming Events</span>
                    </Link>
                  </li> */}
                  <li className={this.routeActive(["event"]) ? "active" : ""} >
                    <Link to="event"  title="Setup Event">
                      <span>Event Setup</span>
                    </Link>
                  </li>
                  <li className={this.routeActive(["results"]) ? "active" : ""}>
                    <Link to="results" title="Upload event results">                
                        <span>Upload Results</span>
                    </Link>
                  </li>             
                </ul>
            </li> 
             {isAdmin && (
              
            <li>
                <a href="#rankingarea" title="Client Management">
                    <em className="fa  fa-trophy" />
                    <span>Ranking</span>
                </a>
                <ul id="rankingarea" className="nav sidebar-subnav">
                 <li className={this.routeActive(["lastrun"]) ? "active" : ""}>
                    <Link to="lastrun" title="View Last Run">                
                        <span>View Last Run Details</span>
                    </Link>
                  </li>
                  <li className={this.routeActive(["ranking"]) ? "active" : ""}>
                    <Link to="ranking" title="View Rankings">                
                        <span>View Rankings</span>
                    </Link>
                  </li>
                </ul>
            </li> 
             )}
           {isAdmin && (
             <li>
              <a href="#postevent" title="Post Event Management">
                <em className="fa  fa-book" />
                <span>Post Event Management</span>
              </a>
              <ul id="posteventarea" className="nav sidebar-subnav">
                <li className={this.routeActive(["exceptions"]) ? "active" : ""}>
                  <Link to="exceptions" title="View Exceptions">                
                      <span>View Exceptions</span>
                  </Link>
                </li>
                <li className={this.routeActive(["reconciliation"]) ? "active" : ""}>
                  <Link to="reconciliation" title="View Exceptions">                
                      <span>Results Reconciliation</span>
                  </Link>
                </li>
              </ul>
           </li>
           )}
           {
            isAdmin && (
            <li>
              <hr style={{ height:'1px' }}/>
            </li>
           )}
           {
             isAdmin && (
             <li className={this.routeActive(["usermanagement"]) ? "active" : ""}>
              <Link to="usermanagement" title="User Management">
                <em className="fa fa-users" />
                <span>User Management</span>
              </Link>
            </li>)
           } 
           
          </ul>
           
          </nav>
        </div>
       
      </aside>
    )
  }
}
Sidebar.propTypes = {
  oidc:object
}
const mapStateToProps = ({  oidc }) => {
	return {
		oidc: { ...oidc }
	}
}
export default withRouter(connect(mapStateToProps,null)(Sidebar))


// WEBPACK FOOTER //
// ./src/components/layout/Sidebar.js